export const OPERATOR = {
  NOT: '!',
  LT: '<',
  GT: '>',
  LTE: '<=',
  GTE: '>=',
  EQ: '='
}

export const getReadableOperator = operator => {
  switch (operator) {
    case OPERATOR.LT:
      return 'Kisebb mint'
    case OPERATOR.GT:
      return 'Nagyobb mint'
    case OPERATOR.GTE:
      return 'Nagyobb egyenlő mint'
    case OPERATOR.LTE:
      return 'Kisebb egyenlő mint'
    case OPERATOR.NOT:
      return 'Nem tartalazza'
    case OPERATOR.EQ:
      return 'Tartalmazza'
  }
}
